export const workstreamTypes = {
  FEATURE: { label: 'Feature Development', color: '#2196F3' },
  BUGFIX: { label: 'Bug Fix', color: '#F44336' },
  RESEARCH: { label: 'Research', color: '#9C27B0' },
  DESIGN: { label: 'Design', color: '#4CAF50' },
  TESTING: { label: 'Testing', color: '#FF9800' },
  DEPLOYMENT: { label: 'Deployment', color: '#795548' }
};

export const DEFAULT_WORKSTREAM_TYPES: Omit<WorkstreamType, 'id'>[] = [
  { name: 'FEATURE', label: 'Feature Development', color: '#2196F3' },
  { name: 'BUGFIX', label: 'Bug Fix', color: '#F44336' },
  { name: 'RESEARCH', label: 'Research', color: '#9C27B0' },
  { name: 'DESIGN', label: 'Design', color: '#4CAF50' },
  { name: 'TESTING', label: 'Testing', color: '#FF9800' },
  { name: 'DEPLOYMENT', label: 'Deployment', color: '#795548' }
];

export const workstreamStatus = {
  PLANNED: { label: 'Planned', variant: 'outlined' },
  IN_PROGRESS: { label: 'In Progress', variant: 'default' },
  COMPLETED: { label: 'Completed', variant: 'filled' }
};

export const milestoneTypes = {
  RELEASE: { label: 'Release', color: '#4CAF50' },
  DEADLINE: { label: 'Deadline', color: '#F44336' },
  REVIEW: { label: 'Review', color: '#FFC107' }
};

export const DEFAULT_STATUSES: Omit<Status, 'id'>[] = [
  { 
    name: 'PLANNED',
    label: 'Planned',
    variant: 'outlined',
    color: '#2196F3'  // Blue
  },
  {
    name: 'IN_PROGRESS',
    label: 'In Progress',
    variant: 'filled',  // changed from 'default'
    color: '#FF9800'  // Orange
  },
  {
    name: 'COMPLETED',
    label: 'Completed',
    variant: 'filled',
    color: '#4CAF50'  // Green
  }
];

export interface WorkstreamType {
  id: string;
  name: string;
  label: string;
  color: string;
}

export interface Milestone {
  id: string;
  name: string;
  date: Date | string;
  type: 'RELEASE' | 'DEADLINE' | 'REVIEW';
  description?: string;
}

export type StatusVariant = 'outlined' | 'filled';  // removed 'default'

export type StatusType = {
  name: string;
  label: string;
  variant: StatusVariant;
  color: string;
};

export interface WorkstreamFormData {
  name: string;
  startDate: Date;
  endDate: Date;
  type: string;
  status: StatusType['name'];  // Use the name property from StatusType
  description: string;
  parentId: string | null;
  isParent: boolean;
  assigneeId: string | null;
}

export interface Workstream {
  id: string;
  name: string;
  startDate: Date | string;
  endDate: Date | string;
  type: string; 
  status: keyof typeof workstreamStatus;
  description?: string;
  parentId?: string | null;
  isParent?: boolean;
  isExpanded?: boolean;
  milestones?: Milestone[];
  assigneeId?: string | null;
}

export interface Assignee {
  id: string;
  name: string;
  email: string;
  avatarUrl?: string;
}

export interface Status {
  id: string;
  name: string;
  label: string;
  variant: 'outlined' | 'default' | 'filled';
  color: string;
}

export interface TimelineConfig {
  view: 'week' | 'month' | 'quarter' | 'year';
  zoomLevel: number;
  startDate: Date;
  endDate: Date;
}

export const isStatusType = (value: unknown): value is Status => {
  return (
    typeof value === 'object' &&
    value !== null &&
    'name' in value &&
    'label' in value &&
    'variant' in value &&
    'color' in value &&
    typeof (value as Status).variant === 'string' &&
    ['outlined', 'default', 'filled'].includes((value as Status).variant)
  );
};